import { http } from '@/utils/request'

// 推荐：直接用 http.getMarqueeCached
export const getTicker = () => {
  return http.getMarqueeCached()
}




